module.exports = __webpack_public_path__ + "quicksilver/static/media/pnb.a838d993.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/banking/pnb.svg
// module id = 642
// module chunks = 0